import DateFnsAdapter from '@date-io/date-fns';

const dateFns = new DateFnsAdapter();

export const formattingDate = (updatedAtString: string): string => {
    const updatedAtDate = new Date(updatedAtString);

    const year = updatedAtDate.getFullYear().toString().slice(-2);
    const month = (updatedAtDate.getMonth() + 1).toString().padStart(2, '0');
    const day = updatedAtDate.getDate().toString().padStart(2, '0');
    const hours = updatedAtDate.getHours().toString().padStart(2, '0');
    const minutes = updatedAtDate.getMinutes().toString().padStart(2, '0');

    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes}`;
    return formattedDate;
};

export const formattingSingleCalender = (updatedAtString: string): string => {
    const updatedAtDate = new Date(updatedAtString);

    const year = updatedAtDate.getFullYear().toString().slice(-2);
    const month = (updatedAtDate.getMonth() + 1).toString().padStart(2, '0');
    const day = updatedAtDate.getDate().toString().padStart(2, '0');

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
};

export const formattingSingleTime = (updatedAtString: string): string => {
    const updatedAtDate = new Date(updatedAtString);

    const hours = updatedAtDate.getHours().toString().padStart(2, '0');
    const minutes = updatedAtDate.getMinutes().toString().padStart(2, '0');

    const formattedDate = ` ${hours}:${minutes}`;
    return formattedDate;
};

export const formattingEpochDiff = (datetime: string): string => {
    const date = new Date(datetime);
    if (date) {
        const diff = dateFns.getDiff(new Date(), new Date(date), 'days');
        const difference = Math.abs(diff);
        return `${difference} days ago`;
    }

    return '-';
};
